import axios from 'axios';
import API_BASE_URL from '../config/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor per aggiungere il token di autenticazione
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor per gestire errori di autenticazione
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Token scaduto, prova a fare refresh
      const refreshToken = localStorage.getItem('refresh_token');
      if (refreshToken) {
        try {
          const response = await axios.post(`${API_BASE_URL}/auth/refresh`, {
            refresh_token: refreshToken,
          });
          
          const { access_token } = response.data;
          localStorage.setItem('access_token', access_token);
          
          // Riprova la richiesta originale
          error.config.headers.Authorization = `Bearer ${access_token}`;
          return api.request(error.config);
        } catch (refreshError) {
          // Refresh fallito, logout
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export const scrapingService = {
  // Ottieni lista risultati scraping
  async getScrapingResults(skip = 0, limit = 100) {
    const response = await api.get(`/scraping/results?skip=${skip}&limit=${limit}`);
    return response.data;
  },

  // Ottieni dettaglio singolo risultato
  async getScrapingResult(id) {
    const response = await api.get(`/scraping/results/${id}`);
    return response.data;
  },

  // Ottieni lotti da un risultato di scraping
  async getLotti(scrapingResultId) {
    const response = await api.get(`/scraping/results/${scrapingResultId}/lotti`);
    return response.data;
  },

  // Scraping PubblicitàLegale
  async startPubblicitalegaleDiscover() {
    const response = await api.post('/scraping/pubblicitalegale/discover');
    return response.data;
  },

  // Ottieni status di un task Celery
  async getTaskStatus(taskId) {
    const response = await api.get(`/scraping/tasks/${taskId}`);
    return response.data;
  }
};

export default scrapingService;
